export default __webpack_public_path__ + "static/media/flash25.2dc469e3.png";